import { useAppStore } from '@/stores/app.store.ts'
import type { Breadcrumb, Job, PageItem, User } from '@/types/model'
import type { ColorKey } from '@/types/tailwind'
import { useTableStore } from '@/stores/table.store.ts'

export const setupApp = (
  data: User | undefined,
  breadcrumbs?: Breadcrumb[],
  sidebar?: PageItem[] | null,
) => {
  // atur search kembali
  const { resetSearch } = useTableStore()
  resetSearch()

  // ambil data dari app store
  const {
    user,
    menubar,
    notification,
    setUser,
    setMenubar,
    setNotification,
    setBreadcrumb,
    setHideBackground,
    setSidebar,
    setLoaded,
  } = useAppStore()

  // set background
  setHideBackground(false)

  // atur data pengguna jika belum ada
  if (user === null) setUser(data)

  // atur data menubar jika belum ada
  if (menubar === null || menubar.length === 0) setMenubar(data?.pages)

  // atur data notifikasi jika notification
  if (notification === null) {
    const config = data?.configs
    if (config) {
      const status = config.notification_status
      const message = config.notification

      if (status && message) setNotification({ status, message })
    }
  }

  // atur breadcrumb
  setBreadcrumb(breadcrumbs)

  // atur sidebar
  setSidebar(sidebar)

  // atur loaded
  setLoaded(true)
}

export const getColorRow = (row: Job, affected: boolean = true): ColorKey | null => {
  if (row.status === 10) return row.states?.color ?? 'stone'

  // langsung cut bagi yang tidak terdampat kecuali cancel
  if (!affected) return null
  if (row.quality_report === 1) return 'purple'
  return null
}
